export const APP_COMMAND_KEY = '__app_command__';
//# sourceMappingURL=types.js.map